import React from "react";

// Topic icons (rendered white via filter)
import IcoGlobe from "../../../assets/images/sezione-05-popup-04-ico-01.svg";      // E1
import IcoChart from "../../../assets/images/sezione-05-popup-04-ico-02.svg";      // S1
import IcoHandsPeople from "../../../assets/images/sezione-05-popup-04-ico-03.svg";// S2
import IcoHands from "../../../assets/images/sezione-05-popup-04-ico-04.svg";      // S3
import IcoNetwork from "../../../assets/images/sezione-05-popup-04-ico-05.svg";    // S4
import IcoPeople from "../../../assets/images/sezione-05-popup-04-ico-06.svg";     // G1
import IcoLeaf from "../../../assets/images/ico_popup_finalità/sezione-05-popup-03-01-ico-04.svg"; // E4 (placeholder)

// Illustrations
import IllObiettivi from "../../../assets/images/sezione-05-analisi-obiettivi.svg"; // people + target
import IllMutualita from "../../../assets/images/sezione5-mutualita-new.svg";

// Official assets
import FrecciaP18 from "../../../assets/images/freccia-p18.svg";                // official arrow (vertical, gradient)
import IcoSocietaBenefit from "../../../assets/images/ico-societa-benefit.svg"; // Benefit Corporation band icon (white)

// ===== Colors (official codes from PDF notes) =====
const C = {
  piano: "#0961C9",      // blue Industrial Plan band
  benefit: "#B25600",    // brown band
  mutualita: "#FFBF00",  // yellow band
  obiettivi: "#DBDDEF",  // light lavender box
  navy: "#0E3761",
};

const WHITE_ICON = { filter: "brightness(0) invert(1)" };

const TOPICS = [
  { code: "E1", title: "Climate change", color: "#2D8406", icon: IcoGlobe },
  { code: "E4", title: "Biodiversity and ecosystems", color: "#277105", icon: IcoLeaf },
  { code: "S1", title: "Own workforce", color: "#B25600", icon: IcoChart },
  { code: "S2", title: "Workers in the value chain", color: "#B25600", icon: IcoHandsPeople },
  { code: "S3", title: "Affected communities", color: "#B25600", icon: IcoHands },
  { code: "S4", title: "Consumers and end-users", color: "#B25600", icon: IcoNetwork },
  { code: "G1", title: "Business conduct", color: "#004291", icon: IcoPeople },
];
const LEFT_COL = ["E1", "S1", "S3", "G1"];
const RIGHT_COL = ["E4", "S2", "S4"];
const byCode = (c) => TOPICS.find((t) => t.code === c);

function TopicCard({ code, title, color, icon }) {
  return (
    <div className="relative pt-5 w-full md:w-[180px]">
      {/* badge */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 z-10 w-[42px] h-[42px] rounded-full bg-white border-2 flex items-center justify-center font-bold text-[17px]"
        style={{ borderColor: color, color }}
      >
        {code}
      </div>
      {/* card */}
      <div
        className="w-full rounded-[16px] pt-7 pb-3 px-2 flex flex-col items-center text-center min-h-[120px] justify-center"
        style={{ background: color }}
      >
        <span className="text-white font-bold text-[13px] md:text-[15px] leading-tight">{title}</span>
        <img src={icon} alt="" className="w-[34px] h-[34px] mt-2" style={WHITE_ICON} />
      </div>
    </div>
  );
}

// full band (Plan / Benefit Corporation)
function Band({ bg, color = "#fff", children, icon }) {
  return (
    <div
      className="rounded-[20px] flex items-center justify-center gap-3 py-4 px-5 text-center"
      style={{ background: bg }}
    >
      {icon}
      <span className="font-bold uppercase text-[16px] md:text-[24px] leading-tight" style={{ color }}>
        {children}
      </span>
    </div>
  );
}

function BuildingIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
      <path d="M3 21V7l6-3v17" /><path d="M9 21V10l9-3v14" /><line x1="2" y1="21" x2="22" y2="21" />
      <line x1="5.5" y1="10" x2="6.5" y2="10" /><line x1="5.5" y1="13" x2="6.5" y2="13" /><line x1="5.5" y1="16" x2="6.5" y2="16" />
      <line x1="12" y1="12" x2="13.5" y2="12" /><line x1="12" y1="15" x2="13.5" y2="15" /><line x1="15" y1="12" x2="16.5" y2="12" /><line x1="15" y1="15" x2="16.5" y2="15" />
    </svg>
  );
}
export default function AnalisiInfografica() {
  return (
    <div className="relative w-full my-10">
      {/* THREE-YEAR INDUSTRIAL PLAN (above the arrow) */}
      <div className="relative z-30">
        <Band bg={C.piano} icon={<BuildingIcon />}>Three-Year Industrial Plan</Band>
      </div>

      {/* MIDDLE: MATERIAL TOPICS + STRATEGIC OBJECTIVES — overlapped on desktop, stacked on mobile */}
      <div className="relative mt-5 md:mt-16 flex flex-col gap-5 md:block md:h-[800px]">
        {/* MATERIAL TOPICS (above, left) */}
        <div className="relative md:absolute md:top-0 md:left-0 md:w-[52%] z-10 bg-white rounded-[20px] border-2 border-[#0E3761] p-12 md:pr-[150px]">
          <h3 className="text-[#0E3761] text-[18px] md:text-[22px] font-bold uppercase text-center mb-5">
            Material topics
          </h3>
          <div className="flex flex-col md:flex-row gap-7 md:gap-4">
            <div className="md:flex-1 flex flex-col gap-7">
              {LEFT_COL.map((c) => <TopicCard key={c} {...byCode(c)} />)}
            </div>
            <div className="md:flex-1 flex flex-col gap-7 md:mt-12">
              {RIGHT_COL.map((c) => <TopicCard key={c} {...byCode(c)} />)}
            </div>
          </div>
        </div>

        {/* STRATEGIC OBJECTIVES (above, lower, right) — white, high z */}
        <div className="relative md:absolute md:top-[170px] md:right-0 md:w-[60%] md:h-[440px] z-[25] rounded-[20px] border-2 border-[#0E3761] bg-white p-5 overflow-hidden">
          {/* lavender background = arrow channel (absolute inside Objectives, overflows at top) */}
          <div
            className="hidden md:block absolute z-0 left-[-2px] bottom-0 w-[145px] h-[440px]"
            style={{ background: C.obiettivi }}
          />
          <h3 className="relative z-10 text-[#0E3761] text-[18px] md:text-[22px] font-bold uppercase text-center">
            Strategic objectives
          </h3>
          {/* illustration ONLY on mobile (inside the box) */}
          <img src={IllObiettivi} alt="" className="block md:hidden relative z-10 mx-auto mt-6 w-[62%]" />
        </div>

        {/* illustration ONLY on desktop (outside the box, overflows above the Benefit band) */}
        <img
          src={IllObiettivi}
          alt=""
          className="hidden md:block absolute z-[99] md:bottom-[-30px] md:right-5 md:h-[540px]"
        />

        {/* Official arrow (desktop only) over the lavender channel, tip below the Plan band */}
        <img
          src={FrecciaP18}
          alt=""
          className="hidden md:block absolute z-[26] left-[46%] -translate-x-1/2 -top-[50px] h-[470px] w-auto"
        />
      </div>

      {/* BENEFIT CORPORATION */}
      <div className="mt-5 md:mt-6">
        <Band bg={C.benefit} icon={<img src={IcoSocietaBenefit} alt="" className="w-[32px] h-[32px] shrink-0" />}>Benefit Corporation</Band>
      </div>

      {/* MUTUALITY AND SUSTAINABILITY — no overflow-hidden: the image can exit the band */}
      <div
        className="relative mt-3 md:mt-4 rounded-[20px] flex items-center justify-center min-h-[110px] md:min-h-[130px] px-5 py-6"
        style={{ background: C.mutualita }}
      >
        <img src={IllMutualita} alt="" className="hidden md:block absolute left-0 -bottom-[200px] w-[38%] z-20" />
        <span className="font-bold uppercase text-[18px] md:text-[28px] md:ml-[200px] text-center" style={{ color: C.navy }}>
          Mutuality and Sustainability
        </span>
      </div>
    </div>
  );
}
